import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ComponentType } from "../../../../modules/manage-components/manage-components.model";
import { ManageComponentsService } from "../../../../modules/manage-components/manage-components.service";
import { SetupUndercarriageService } from "../../../../modules/setup-undercarriage";
import { Make } from "../../../../entities/global/model";
import {
  ChildComponent,
  CompartDto,
  ComponentPosition,
  AddComponentRequest,
} from "../../models/manage-equipment.model";
import { ManageEquipmentService } from "../../manage-equipment.service";
import { componentTypes } from "../../../../shared/enums/allEnums";
import { SystemModelTemplate } from "../../../../entities";
import { NotificationsService } from "angular2-notifications";
import { AddComValidationRequest, AddNewCompValidationViewModel } from "../../models/manage-equipment.model";
import { AddNewComponentValidationComponent } from "../add-new-component/add-new-component-validation/add-new-component-validation";

@Component({
  selector: "app-add-new-component",
  templateUrl: "./add-new-component.html",
  styleUrls: ["./add-new-component.scss"],
})
export class AddNewComponentComponent implements OnInit {
  ComponentType: any;
  Part: any;
  Brand: string;
  Position: number;
  componentTypeList: ComponentType[] = [];
  availableComponentMakes: Make[] = [];
  compartList: CompartDto[] = [];
  SelectedMakeId: number | null = null;
  makeList: any[] = [];
  componentTypes = componentTypes;
  componentPositionList: ComponentPosition[] = [];
  systemTemplate: SystemModelTemplate[] = [];
  isPositionDisabled: boolean = false;
  childCompoentList: ChildComponent[] = [];
  isChild: boolean = false;
  componentPositionSide: any[] = [];
  checked: boolean = false; // For child component checkbox
  selectedCompartId: any;
  EquipmentComponent: any;
  parentPosition: number = 1; // For parent position
  isSaveEnabled: boolean = false;
  postionIncrement: number = 0;
  newCompartId: number = 0;
  systemType: number = 0;
  isReplaceExistingTab: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AddNewComponentComponent>,
    private _componentservice: ManageComponentsService,
    private _setupService: SetupUndercarriageService,
    private _manageEquipmentService: ManageEquipmentService,
    private _notify: NotificationsService,
    private dialog: MatDialog
  ) {}
  ngOnInit(): void {
    this.isReplaceExistingTab = this.data.IsReplaceExistingTab;
    this.getSystemTemplate();
    this.getComponentType();
    console.log("save", this.isSaveEnabled);
  }

  getComponentType() {
    this._componentservice.getComponentType().subscribe((result) => {
      this.componentTypeList = result;
    });
  }

  changeComponentType(event: any) {
    this.ComponentType = event.value;
    this.getEquipmentComponent();
    //this.getCompartList();
    this.loadComponentPositions(this.data.EquipmentId, this.ComponentType);
  }

  getEquipmentComponent() {
    this._manageEquipmentService
      .GetEquipmentComponent(this.ComponentType, this.data.EquipmentId)
      .subscribe((result) => {
        this.EquipmentComponent = result.Data[0]?.CompartId;
        console.log(this.EquipmentComponent);
        this.getCompartList();
      });
  }

  getCompartList() {
    this._manageEquipmentService
      .getCompartList(this.ComponentType, this.data.EquipmentId, this.EquipmentComponent)
      .subscribe((result) => {
        this.compartList = result.Data;
        console.log('this.compartList', this.compartList);
        if (
          this.ComponentType == 230 ||
          this.ComponentType == 231 ||
          this.ComponentType == 232
        ) {
          this.selectedCompartId = this.compartList[0]?.CompartId || null;
        } else {
          this.selectedCompartId = this.EquipmentComponent;
            // this.compartList.filter(
            //   (x) => x.CompartId == this.EquipmentComponent
            // )[0]?.CompartId || null;
          console.log(this.selectedCompartId);
        }

        this.getChildComponent();
        this.getBrandList();
      });
  }

  changePartNumber(event: any) {
    this.selectedCompartId = event.value;
    this.getChildComponent();
    this.getBrandList();
  }

  // getChildComponent() {
  //   this._manageEquipmentService
  //     .GetChildComponent(this.selectedCompartId, this.data.EquipmentId)
  //     .subscribe((result) => {
  //       this.childCompoentList = result.Data;
  //       if (this.childCompoentList.length > 0) {
  //         this.isChild = true;
  //         this.isSaveEnabled = !this.isChild || this.childCompoentList?.some((c) => c.IsChild);
  //         console.log('save', this.isSaveEnabled);
  //       } else {
  //         this.isChild = false;
  //       }
  //     });
  // }
  getChildComponent() {
    this._manageEquipmentService
      .GetChildComponent(this.selectedCompartId, this.data.EquipmentId)
      .subscribe((result) => {
        this.childCompoentList = (result.Data || []).map((c) => ({
          ...c,
          UserSelectable: !c.IsChild, // Only unchecked items are toggleable
        }));

        this.isChild = this.childCompoentList.length > 0;
        this.isSaveEnabled = !this.isChild || this.childCompoentList.some((c) => c.IsChild && c.UserSelectable);
      });
  }

  onCheckboxChange(event: any, compartId: number): void {
    console.log(event);
    this.checked = event.checked;
    this.selectedCompartId = compartId;
    this.isSaveEnabled = this.childCompoentList.some(c => c.IsChild && c.UserSelectable);
    console.log("SAVE", this.isSaveEnabled);
  }
  //Setup UC
  getBrandList() {
    const brand = this.compartList.find(
      (x) => x.CompartId === this.selectedCompartId
    ).Brand;
    this._componentservice.getComponentMakeList().subscribe((result) => {
      this.makeList = result;
      const matchedMake = this.makeList.find((m) => m.Name === brand);
      if (matchedMake) {
        this.SelectedMakeId = matchedMake.Id;
      } else {
        this.SelectedMakeId = null;
      }
    });
  }
  //SetupComponent
  // getBrandList() {
  //   const brand = this.compartList.find(x => x.CompartId === this.selectedCompartId).Brand;
  //   this._setupService.getComponentMakeList().subscribe((result) => {
  //     this.availableComponentMakes = result;
  //     const matchedMake = this.availableComponentMakes.find(
  //       (m) => m.Title === brand
  //     );
  //     if (matchedMake) {
  //       this.SelectedMakeId = matchedMake.Id;
  //     } else {
  //       this.SelectedMakeId = null;
  //     }
  //   });
  // }
  brandSelected(event: any) {
    if (!event.value) return;
    const selected = this.availableComponentMakes.find(
      (m) => m.Id === event.value
    );
  }
  onNoClick() {
    this.dialogRef.close(false);
  }

  loadComponentPositions(equipmentId: number, compartTypeId: number) {
    this._manageEquipmentService
      .GetComponentPosition(equipmentId, compartTypeId)
      .subscribe({
        next: (response) => {
          if (response.Status === 1 && response.Data) {
            this.componentPositionList = response.Data;
            this.componentPositionSide = this.componentPositionList.filter(
              (p) => p.Side === 1
            );
            console.log("Component Position", this.componentPositionList);
            //this.postionIncrement = this.componentPositionList.filter(x => x.Side === 1)[0].Pos;
            // Find max position
            this.postionIncrement = Math.max(...this.componentPositionSide.map(x => x.Pos));
            // const matchingTemplate = this.systemTemplate.find(
            //   (t) => t.CompartTypeId === compartTypeId
            // );

            // if (matchingTemplate) {
            //   const maxAllowed = matchingTemplate.Max;
            //   const sideOnePositions = this.componentPositionList.filter(p => p.Side === 1);
            //   const currentCount = sideOnePositions.length;

            //   if (currentCount < maxAllowed) {
            //     const highestPos = sideOnePositions.reduce((max, item) => item.Pos > max ? item.Pos : max, 0);
            //     this.componentPositionList.push({
            //       Pos: highestPos + 1,
            //       Side: 1
            //     });
            //   }

            //   this.isPositionDisabled = false;
            // } else {
            //   this.isPositionDisabled = false;
            // }
          } else {
            console.error("Failed to load positions:", response.Message);
          }
        },
        error: (err) => {
          console.error("API error:", err);
        },
      });
  }
  getSystemTemplate() {
    this.systemTemplate = [];
    this._setupService
      .GetTemplateForEquipment(this.data.EquipmentId)
      .subscribe((template) => {
        this.systemTemplate.push(...template);
        console.log("System Template:", this.systemTemplate);
      });
  }

  onPositionSelected(event: any) {
    this.parentPosition = event.Pos;
    console.log("Selected Position:", this.parentPosition);
  }

  private updateSaveEnabled() {
    const mustHaveParent =
      this.isChild &&
      this.childCompoentList?.length &&
      ![230, 231, 232, 236].includes(this.ComponentType);

    this.isSaveEnabled =
      (!this.isChild ||
        this.childCompoentList.some(c => c.IsChild && c.UserSelectable)) &&
      (!mustHaveParent || !!this.Position);
  }

  onSave() {
    const mustHaveParent = this.isChild && this.childCompoentList?.length 
      && ![230, 231, 232, 236].includes(this.ComponentType);

    if (mustHaveParent && !this.Position) {
      this._notify.warn('Please select a Parent Position.');
      return;
    }

    if(this.ComponentType == 230 || this.ComponentType == 231 || this.ComponentType == 232 ||this.ComponentType == 240 )
      this.systemType = 1;
    else 
      this.systemType = 2;
    const validation: AddComValidationRequest = {
      EquipmentId: this.data.EquipmentId,
      SystemTypeId: this.systemType
    };

    this._manageEquipmentService.addNewComponentValidation(validation).subscribe({
      next: (res) => {
        if (res?.Status === 1) {
          if(res.Data?.length > 0){
            this.openWarningPopup(res.Data);
          } else {
            this.onValidate();
          }
        } else{
          console.error('Error', res.Message);
          this._notify.error(res.Message);
        }
      },
      error: (err) => {
        this._notify.error('Something went wrong while saving.');
        console.error(err);
      }
    })
  }

  openWarningPopup(res: AddNewCompValidationViewModel[]){
    const dialogRef = this.dialog.open(AddNewComponentValidationComponent, {
      disableClose: true,
      maxHeight: '50vw',
      width: '1032px',
      data: {
        Data: res,
        IsReplaceExistingTab: this.isReplaceExistingTab
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result)
        this.onValidate();
    });
  }

  onValidate(){
    const request: AddComponentRequest = {
      EquipmentId: this.data.EquipmentId,
      CompartId: this.selectedCompartId,
      CompartTypeId: this.ComponentType,
      BrandId: this.SelectedMakeId,
      IsChild: this.checked,
      ParentPosition: this.parentPosition,
    };
    this._manageEquipmentService.addNewComponent(request).subscribe({
      next: (res) => {
        if (res?.Status === 1) {
          this._notify.success(res.Message);
          this.dialogRef.close(true);
        }
        else if (res?.Status === 2) {
          this._notify.warn(res.Message); 
        }
        else {
          this._notify.error(res.Message);
        }
      },
      error: (err) => {
        this._notify.error('Something went wrong while saving.');
        console.error(err);
      },
    });
  }
}
